import { brighten } from 'components/planner/utils/tools';
import { KonvaEventObject } from 'konva/lib/Node';
import { useMemo } from 'react';
import { Rect } from 'react-konva';
import { diffDay } from 'utils/time';
import { Activity, GraphStyle, TAGS } from "../../types";



function ActivityCompact({
	start,
	activity,
	highlight,
	disabled,
	onCellEnter,
	onCellLeave,
	onCellClick,
	onCellDoubleClick,
	style,
}: ActivityCompactProps) {

	// HOOKS
	// get colors
	const color = useMemo(() =>
		disabled
			? brighten(activity.color, .4)
			: (highlight ? brighten(activity.color, 1.4) : activity.color),
		[highlight, disabled, activity, style.activity]
	)

	// HANDLERs
	const handleMouseEnter = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		onCellEnter(e)
	}
	const handleMouseLeave = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		onCellLeave(e)
	}
	const handleClick = (e: KonvaEventObject<MouseEvent>) => {
		e.cancelBubble = true
		onCellClick(e)
	}

	// RENDER
	const inSession = !style.sessionHighlight || activity.tags?.[TAGS.SESSION] == style.sessionHighlight
	const length = activity.length
	const col = diffDay(activity.start, start)
	const row = activity.row
	const startX = col * style.space.x
	const startY = row * style.compact.y
	const opacity = inSession ? 1 : .4
	const inOverlap = activity.overlaps?.length > 0
	const strokeColor = inOverlap ? style.activity.overlap.color : null
	const strokeWidth = inOverlap ? style.activity.overlap.thickness : null

	return <Rect transformsEnabled="position"
		x={startX + style.activity.compact.margin}
		y={startY + style.activity.compact.top}
		width={(length * style.space.x) - (style.activity.compact.margin * 2)}
		height={style.activity.compact.height}
		fill={color}
		opacity={opacity}

		// [II] da capire....
		stroke={strokeColor}
		strokeWidth={strokeWidth}
		fillAfterStrokeEnabled
		//strokeEnabled={!!activity._edit}
		hitStrokeWidth={5}

		onMouseEnter={handleMouseEnter}
		onMouseLeave={handleMouseLeave}
		onClick={handleClick}
		onTap={handleClick}
		onDblClick={onCellDoubleClick}
		onDblTap={onCellDoubleClick}
	/>
}

export default ActivityCompact

type ActivityCompactProps = {
	start?: number,
	activity?: Activity,
	highlight?: boolean,
	disabled?: boolean,
	onCellEnter?: (e: KonvaEventObject<MouseEvent>) => void,
	onCellLeave?: (e: KonvaEventObject<MouseEvent>) => void,
	onCellClick?: (e: KonvaEventObject<MouseEvent>) => void,
	onCellDoubleClick?: (e: KonvaEventObject<MouseEvent>) => void,
	style?: GraphStyle,
}